/**
 * Routes where the player is not yet in an authenticated game session.
 * Season warnings / season-end dialog must never appear here — identity is unknown.
 */

const PRE_LOGIN_EXACT = new Set(['/', '']);

const PRE_LOGIN_PREFIXES = [
  '/register',
  '/confirm-email',
  '/resend-confirmation',
  '/request-password-reset',
  '/reset-password',
  '/auth/google/callback',
];

/**
 * @param {string} pathname
 * @returns {boolean}
 */
export function isPreLoginAuthPath(pathname) {
  if (pathname == null) {
    throw new Error('isPreLoginAuthPath: pathname is required');
  }
  const path = String(pathname).split('?')[0];
  if (PRE_LOGIN_EXACT.has(path)) {
    return true;
  }
  return PRE_LOGIN_PREFIXES.some(
    (prefix) => path === prefix || path.startsWith(`${prefix}/`)
  );
}

export default isPreLoginAuthPath;
